import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-primary-500 text-background-50">
      <div className="px-4 md:px-8 py-14 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="mb-12">
            <span className="text-4xl md:text-6xl font-heading font-black tracking-tight">
              51<span className="text-accent-500">吃瓜</span>
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-14">
            <div>
              <p className="text-sm md:text-base text-background-50/70 leading-relaxed max-w-xs">
                {siteInfo.description}
              </p>
              <div className="flex items-center gap-4 mt-6">
                <a href="#" className="w-10 h-10 rounded-full border border-background-50/30 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-background-50/30 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-background-50/30 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 rounded-full border border-background-50/30 flex items-center justify-center text-background-50 hover:bg-background-50/10 transition-colors cursor-pointer" aria-label="B站">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-wider text-background-50/50 mb-6 font-label">联系方式</h4>
              <div className="space-y-4">
                <p className="text-sm text-background-50/80">地址：{siteInfo.address}</p>
                <p className="text-sm text-background-50/80">电话：{siteInfo.phone}</p>
                <p className="text-sm text-background-50/80">邮箱：{siteInfo.email}</p>
              </div>
              <div className="mt-8">
                <h4 className="text-xs uppercase tracking-wider text-background-50/50 mb-4 font-label">热门分类</h4>
                <div className="flex flex-wrap gap-2">
                  {categories.slice(0, 4).map((cat) => (
                    <Link
                      key={cat.slug}
                      to="/category/all"
                      className="text-xs text-background-50/70 hover:text-accent-500 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            <div>
              <h4 className="text-xs uppercase tracking-wider text-background-50/50 mb-6 font-label">热门标签</h4>
              <div className="flex flex-wrap gap-2">
                {['网红翻车', '塌房现场', '吃瓜爆料', '直播带货', '人设崩塌', '明星八卦', '网红黑料', '内幕揭秘'].map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1.5 rounded-full border border-background-50/20 text-xs text-background-50/70 hover:border-accent-500/50 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} {siteInfo.name}. All Rights Reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/about" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">关于我们</Link>
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-50/50 hover:text-background-50/80 transition-colors whitespace-nowrap">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}